import { render, staticRenderFns } from "./WizardCoreValuesStep.vue?vue&type=template&id=67b26625&scoped=true&"
import script from "./WizardCoreValuesStep.vue?vue&type=script&lang=js&"
export * from "./WizardCoreValuesStep.vue?vue&type=script&lang=js&"
import style0 from "./WizardCoreValuesStep.vue?vue&type=style&index=0&id=67b26625&lang=scss&scoped=true&"
import style1 from "./WizardCoreValuesStep.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b26625",
  null
  
)

export default component.exports